import type {SetURLSearchParams} from 'react-router-dom';
import {errorMessage} from '../errors';
import {toast} from '../components/ui/sonner';

interface OutcomeContext {
  result: string | null; refresh: () => Promise<void>;
  setParams: SetURLSearchParams; handled: {current: string | null};
}

function withoutGmailOutcome(current: URLSearchParams): URLSearchParams {
  const next = new URLSearchParams(current); next.delete('gmail'); return next;
}

function notifyOutcome(result: string): void {
  if (result === 'connected') { toast.success('Gmail connected. Your inbox is ready to sync.'); return; }
  toast.error(result === 'denied' ? 'Gmail access was not granted. Nothing was connected.' : 'Gmail could not connect. Check the setup details and try again.');
}

export function consumeGmailOutcome({result, refresh, setParams, handled}: OutcomeContext): void {
  if (!result) { handled.current = null; return; }
  if (handled.current === result) return;
  handled.current = result;
  notifyOutcome(result);
  void refresh().catch(failure => toast.error(errorMessage(failure)));
  setParams(withoutGmailOutcome, {replace: true});
}